// removed by extract-text-webpack-plugin
module.exports = {"vcenter":"src-components-Events-EventsDescriptionSection-components-Section----styles-module---vcenter---3Ejb7","paddingLeft":"src-components-Events-EventsDescriptionSection-components-Section----styles-module---paddingLeft---15AeO","paddingRight":"src-components-Events-EventsDescriptionSection-components-Section----styles-module---paddingRight---hDZQK"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Events/EventsDescriptionSection/components/Section/styles.module.scss
// module id = 1869
// module chunks = 172792206850227